<template>
  <div class="contents contents--full layout-wrapper">
    <div class="contents__wrap">
      <div class="sub-top">
        <h3>IQC {{checkUserId.memberName}}의 내부통제체계 진단 입력</h3>
        <!-- <select v-model="selectedYear" class="year-dropdown">
            <option v-for="year in availableYears" :key="year" :value="year">
              {{ year }}
            </option>
        </select>
        <button class="load-button" @click="loadYearData">
          불러오기
        </button> -->
        <div class="sub-top__navi">
          <span class="icon-home navi--home"></span>
          <span>평가</span>
          <span>내부통제체계 진단 실시</span>
        </div>
      </div>

      <!-- 로딩 화면 -->
      <div v-if="isLoading" class="loading-overlay">
        <div class="spinner"></div>
        <p>{{ hasData === 'insert' ? '저장 중입니다...' : '수정 중입니다...' }}</p>
      </div>

      <!-- 트리 구조 렌더링 -->
      <div class="evaluation-tree">
        <!-- Level 1: Domain -->
        <div v-for="(domain, domainIndex) in transformedDomains" :key="domainIndex" class="tree-node level-1">
          <div class="tree-node__header" @click="toggleSubItem(domain.domainCode)">
            <div class="node-title">
              <span class="korean-text">{{ koreanPart(domain.domainName) }}</span>
              <span class="english-text">({{ englishPart(domain.domainName) }})</span>
              <span v-if="domain.hasRedDot" class="red-text">검토필요</span>
            </div>
          </div>

          <!-- Level 2: Principle -->
          <div v-show="subItemsVisibility[domain.domainCode]" class="tree-node__body">
            <div v-for="(principle, principleIndex) in domain.principles" :key="principleIndex" class="tree-node level-2">
              <div class="tree-node__header" @click="toggleSubItemStandard(domain.domainCode, principle.principleCode)">
                <!-- <span class="node-title">{{ principle.principleCode }} - {{ principle.principleName }}</span> -->
                <div class="node-title">
                  <span>{{ principle.principleCode }} - </span>
                  <span class="korean-text">{{ koreanPart(principle.principleName) }}</span>
                  <span class="english-text">({{ englishPart(principle.principleName) }})</span>
                  <!-- <span class="english-text">{{principle.principleName}}</span> -->
                  <!-- <div class="help-icon-wrapper">
                    <div class="help-icon">?</div>
                    <span class="tooltip">{{ principle.principleContent }}</span>
                  </div> -->
                  <span v-if="principle.hasRedDot" class="red-text">검토필요</span>
                </div>
              </div>

              <!-- Level 3: Standard -->
              <div v-show="subItemsVisibilityStandard[`${domain.domainCode}-${principle.principleCode}`]" class="tree-node__body">
                <div v-for="(standard, standardIndex) in principle.standards" :key="standardIndex" class="tree-node level-3">
                  <div class="tree-node__header" @click="toggleSubItemEvaluation(domain.domainCode, principle.principleCode, standard.standardCode)">
                    <!-- <span class="node-title">{{ standard.standardCode }} - {{ standard.standardName }}</span> -->
                    <div class="node-title">
                      <span>{{ standard.standardCode }} - </span>
                      <span class="korean-text">{{ koreanPart(standard.standardName) }}</span>
                      <!-- <span class="english-text">({{ englishPart(standard.standardName) }})</span> -->
                      <!-- <div class="help-icon-wrapper" v-if="standard.standardContent">
                        <div class="help-icon">?</div>
                        <span class="tooltip-stand">{{ standard.standardContent }}</span>
                      </div> -->
                      <span v-if="standard.hasRedDot" class="red-text">검토필요</span>
                    </div>
                  </div>

                  <!-- Level 4: Evaluation -->
                  <div v-show="evaluationVisibility[`${domain.domainCode}-${principle.principleCode}-${standard.standardCode}`]" class="tree-node__content">
                    <div 
                      v-for="(evaluation, evalKey) in standard.evaluations" 
                      :key="evaluation.evaluationCode" 
                      class="tree-node level-4"
                    >
                      <div class="tree-node__header">
                        {{ evaluation.evaluationCode }} - {{ evaluation.evaluationName }}
                          <!-- 레드닷 표시 -->
                          <span 
                            v-if="iqcNeedsAttention[evaluation.evaluationCode] === 'Y'" 
                            class="red-text"
                          >검토필요</span>
                      </div>

                      <div class="input-group"
                      :class="{ 'no-timestamp': !evaluationCurrentTime[evaluation.evaluationCode] }">
                        <div class="textarea-wrapper"
                        :class="{ 'full-width': !evaluationCurrentTime[evaluation.evaluationCode] }">
                          <label>
                            <span style="font-weight: bold; font-size: 1em;">
                              Approach:
                            </span>
                            <div class="help-icon-wrapper"
                            @click.stop="handleTooltipClick(evaluation.evaluationCode)">
                              <div class="help-icon">?</div>
                              <span class="tooltip" :class="{ 'visible': tooltipVisible[evaluation.evaluationCode] }">{{ evaluation.evaluationApproachContent }}</span>
                            </div>
                          </label>
                          <textarea
                            v-model="evaluationContent[evaluation.evaluationCode]"
                            :readonly="!approvedCodes.includes(evaluation.evaluationCode) || iqcCompletedYn[evaluation.evaluationCode] =='Y'"
                          ></textarea>
                        </div>
                        <div class="timestamp-box" 
                        v-if="evaluationCurrentTime[evaluation.evaluationCode]">
                          <label>최근 저장 일시:</label>
                          <div class="timestamp">
                            <div 
                              v-if="evaluationCurrentTime[evaluation.evaluationCode]" 
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="resetEvaluationContent(evaluation.evaluationCode)"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrentTime[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent2Time[evaluation.evaluationCode]" 
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent2Time[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent3Time[evaluation.evaluationCode]" 
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent3Time[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent4Time[evaluation.evaluationCode]" 
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent4Time[evaluation.evaluationCode] }}
                            </div>
                            <div 
                              v-if="evaluationCurrent5Time[evaluation.evaluationCode]" 
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationContent(evaluation.evaluationCode, evaluationContent5[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationCurrent5Time[evaluation.evaluationCode] }}
                            </div>
                          </div>
                          
                        </div>
                      </div>

                    <!-- 개선사항 입력 -->
                     <div class="input-group"
                    :class="{ 'no-timestamp': !evaluationImpTime[evaluation.evaluationCode] }"
                    >
                      <div class="textarea-wrapper"
                      :class="{ 'full-width': !evaluationImpTime[evaluation.evaluationCode] }"
                      >
                       <label>
                          <span style="font-weight: bold; font-size: 1em;">
                            Deployment:
                          </span>
                             <div class="help-icon-wrapper"
                            @click.stop="handleTooltipClick(evaluation.evaluationCode)">
                              <div class="help-icon">?</div>
                              <span class="tooltip" :class="{ 'visible': tooltipVisible[evaluation.evaluationCode] }">{{ evaluation.evaluationDeploymentContent }}</span>
                            </div>
                        </label>
                        <textarea
                          v-model="evaluationImprovements[evaluation.evaluationCode]"
                          :readonly="!approvedCodes.includes(evaluation.evaluationCode) || iqcCompletedYn[evaluation.evaluationCode] =='Y' "
                        ></textarea>
                      </div>
                      <div class="timestamp-box" v-if="evaluationImpTime[evaluation.evaluationCode]">
                        <label>최근 저장 일시:</label>
                        <div class="timestamp">
                          <div
                            v-if="evaluationImpTime[evaluation.evaluationCode]"
                            @click="resetEvaluationImprovements(evaluation.evaluationCode)"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            class="timestamp-item"
                          >
                            {{ evaluationImpTime[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp2Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp2Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp3Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp3Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp4Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp4Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationImp5Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationImprovements(evaluation.evaluationCode, evaluationImprovements5[evaluation.evaluationCode] ,iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationImp5Time[evaluation.evaluationCode] }}
                          </div>
                        </div>
                        
                      </div>
                    </div> 


                    <!-- 모니터링 입력 -->
                     <div class="input-group"
                    :class="{ 'no-timestamp': !evaluationMonitoringTime[evaluation.evaluationCode] }"
                    >
                      <div class="textarea-wrapper"
                      :class="{ 'full-width': !evaluationMonitoringTime[evaluation.evaluationCode] }"
                      >
                      <label>
                        <span style="font-weight: bold; font-size: 1em;">
                          Monitoring Process:
                        </span>
                          <div class="help-icon-wrapper"
                            @click.stop="handleTooltipClick(evaluation.evaluationCode)">
                              <div class="help-icon">?</div>
                              <span class="tooltip" :class="{ 'visible': tooltipVisible[evaluation.evaluationCode] }">{{ evaluation.evaluationMonitoringContent }}</span>
                          </div>
                      </label>
                        <textarea
                          v-model="evaluationMonitoring[evaluation.evaluationCode]"
                          :readonly="!approvedCodes.includes(evaluation.evaluationCode) || iqcCompletedYn[evaluation.evaluationCode] =='Y' "
                        ></textarea>
                      </div>
                      <div class="timestamp-box" v-if="evaluationMonitoringTime[evaluation.evaluationCode]">
                        <label>최근 저장 일시:</label>
                        <div class="timestamp">
                          <div
                            v-if="evaluationMonitoringTime[evaluation.evaluationCode]"
                            @click="resetEvaluationMonitoring(evaluation.evaluationCode)"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            class="timestamp-item"
                          >
                            {{ evaluationMonitoringTime[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationMonitoring2Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationMonitoring(evaluation.evaluationCode, evaluationMonitoring2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationMonitoring2Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationMonitoring3Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationMonitoring(evaluation.evaluationCode, evaluationMonitoring3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationMonitoring3Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationMonitoring4Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationMonitoring(evaluation.evaluationCode, evaluationMonitoring4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationMonitoring4Time[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationMonitoring5Time[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationMonitoring(evaluation.evaluationCode, evaluationMonitoring5[evaluation.evaluationCode] ,iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationMonitoring5Time[evaluation.evaluationCode] }}
                          </div>
                        </div>
                        
                      </div>
                    </div> 


                    <div class="input-group"
                      :class="{ 'no-timestamp': !evaluationActionTime[evaluation.evaluationCode] }"
                      >
                        <div class="textarea-wrapper"
                        :class="{ 'full-width': !evaluationActionTime[evaluation.evaluationCode] }"
                        >
                          <label>
                            <span style="font-weight: bold; font-size: 1em;">
                              Action:
                            </span>
                              <!-- <div class="help-icon-wrapper">
                                <div class="help-icon">?</div>
                                <span class="tooltip">{{ evaluation.evaluationActionContent }}</span>
                              </div> -->
                              <div class="help-icon-wrapper"
                              @click.stop="handleTooltipClick(evaluation.evaluationCode)">
                              <div class="help-icon">?</div>
                              <span class="tooltip" :class="{ 'visible': tooltipVisible[evaluation.evaluationCode] }">{{ evaluation.evaluationActionContent }}</span>
                              </div>
                          </label>
                          <textarea
                            v-model="evaluationAction[evaluation.evaluationCode]"
                            :readonly="!approvedCodes.includes(evaluation.evaluationCode) || iqcCompletedYn[evaluation.evaluationCode] =='Y' "
                          ></textarea>
                        </div>
                        <div class="timestamp-box" v-if="evaluationActionTime[evaluation.evaluationCode]">
                          <label>최근 저장 일시:</label>
                          <div class="timestamp">
                            <div
                              v-if="evaluationActionTime[evaluation.evaluationCode]"
                              @click="resetEvaluationAction(evaluation.evaluationCode)"
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              class="timestamp-item"
                            >
                              {{ evaluationActionTime[evaluation.evaluationCode] }}
                            </div>
                            <div
                              v-if="evaluationAction2Time[evaluation.evaluationCode]"
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationAction(evaluation.evaluationCode, evaluationAction2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationAction2Time[evaluation.evaluationCode] }}
                            </div>
                            <div
                              v-if="evaluationAction3Time[evaluation.evaluationCode]"
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationAction(evaluation.evaluationCode, evaluationAction3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationAction3Time[evaluation.evaluationCode] }}
                            </div>
                            <div
                              v-if="evaluationAction4Time[evaluation.evaluationCode]"
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationAction(evaluation.evaluationCode, evaluationAction4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationAction4Time[evaluation.evaluationCode] }}
                            </div>
                            <div
                              v-if="evaluationAction5Time[evaluation.evaluationCode]"
                              :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                              @click="updateEvaluationAction(evaluation.evaluationCode, evaluationAction5[evaluation.evaluationCode] ,iqcCompletedYn[evaluation.evaluationCode])"
                              class="timestamp-item"
                            >
                              {{ evaluationAction5Time[evaluation.evaluationCode] }}
                            </div>
                          </div>
                          
                        </div>
                     </div> 
                    
                     <!-- 검토 요청사항 -->
                    <div class="input-group"
                    v-if="!approvedCodes.includes(evaluation.evaluationCode)"
                    :class="{ 'no-timestamp': !evaluationCmtTime[evaluation.evaluationCode] }">
                      <div class="textarea-wrapper"
                      :class="{ 'full-width': !evaluationCmtTime[evaluation.evaluationCode] }"
                      >
                        <label>검토 요청사항:</label>
                        <textarea
                          v-model="evaluationComment[evaluation.evaluationCode]"
                          :readonly="iqcCompletedYn[evaluation.evaluationCode] =='Y'"
                        ></textarea>
                      </div>
                      <div class="timestamp-box" v-if="evaluationCmtTime[evaluation.evaluationCode]" >
                        <label>최근 저장 일시:</label>
                        <div class="timestamp" :readonly="iqcCompletedYn[evaluation.evaluationCode] =='Y'" >
                          <div
                            v-if="evaluationCmtTime[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="resetEvaluationComment(evaluation.evaluationCode,iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime2[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment2[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime2[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime3[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment3[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime3[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime4[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment4[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime4[evaluation.evaluationCode] }}
                          </div>
                          <div
                            v-if="evaluationCmtTime5[evaluation.evaluationCode]"
                            :class="{ 'disabled': iqcCompletedYn[evaluation.evaluationCode] === 'Y' }"
                            @click="updateEvaluationComment(evaluation.evaluationCode, evaluationComment5[evaluation.evaluationCode],iqcCompletedYn[evaluation.evaluationCode])"
                            class="timestamp-item"
                          >
                            {{ evaluationCmtTime5[evaluation.evaluationCode] }}
                          </div>
                        </div>
                        <div class="return-button-wrapper">
                          <button
                            class="return-button"
                             @click="markFeedbackAsComplete(evaluation.evaluationCode)"
                             v-if="iqcNeedsAttention[evaluation.evaluationCode] === 'Y'">
                            검토 완료
                          </button>
                        </div>
                      </div>
                    </div>
                    

                    <div class="input-group" v-if="eqcComment[evaluation.evaluationCode]">
                      <div class="textarea-wrapper full-width">
                        <label>개선 권고사항:</label>
                        <textarea
                          v-model="eqcComment[evaluation.evaluationCode]"
                          readonly
                        ></textarea>
                      </div>
                    </div>
                      
                    <!-- 점수 슬라이더 -->
                    <!-- <div class="input-group">
                      <label>점수:</label>
                      <div class="custom-slider">

                        <input 
                          type="range"
                          :value="evaluationScore[evaluation.evaluationCode]"
                          min="0"
                          max="5"
                          step="1"
                          @input="updateSlider(evaluation.evaluationCode, $event)"
                          :disabled="!approvedCodes.includes(evaluation.evaluationCode) || iqcCompletedYn[evaluation.evaluationCode] == 'Y'"
                        />
                        <div 
                          class="slider-thumb"
                          :style="{
                            left: `${(evaluationScore[evaluation.evaluationCode] - 1) * 20}%`,
                            background: getSliderColor(evaluationScore[evaluation.evaluationCode])
                          }"
                        >
                        {{ evaluationScore[evaluation.evaluationCode] == 0 
                          ? '➡' 
                          : `${evaluationScore[evaluation.evaluationCode]}점` }}
                          
                        </div>
                      </div>
                    </div> -->

                    <!-- 파일 업로드 -->
                    <div class="input-group">
                      <label>첨부파일:</label>
                      <input 
                        type="file"
                        @change="handleFileUpload(evaluation.evaluationCode, $event)" 
                        multiple
                        :disabled="!approvedCodes.includes(evaluation.evaluationCode) ||iqcCompletedYn[evaluation.evaluationCode] == 'Y'"
                      />
                    </div>

                        <!-- 파일 목록 -->
                      <ul class="attach-list">
                        <li v-for="(file, fileIndex) in evaluationFiles[evaluation.evaluationCode] || []" :key="fileIndex">
                          {{ file.name }}
                          <button @click="removeFile(evaluation.evaluationCode, fileIndex)"
                          v-if="approvedCodes.includes(evaluation.evaluationCode) && iqcCompletedYn[evaluation.evaluationCode] != 'Y'">❌</button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 저장 버튼 -->
      <div class="save-button-container" >
        <button @click="saveData(hasData)" :disabled="isSubmitDisabled">
          {{ hasData === 'insert' ? '임시저장' : '임시저장' }}
        </button>

        <button @click="SaveCmt":disabled="isSubmitDisabled">
          피드백 저장
        </button>

        <button @click="finalSaveData(hasData)" v-if="hasData != 'insert'" :disabled="isSubmitDisabled">
          평가완료
        </button>
      </div>

    </div>
  </div>
</template>


<script setup>
import { reactive, ref, computed, onMounted,onUnmounted,toRaw } from "vue";
import { useStore } from "vuex";
import { insertGias ,updateGias,updateGiasFile,getIQCApproveList,updateFeedbackForIQA,
  updateFeedbackCompletionStatus,
  finalizeEvaluation
 } from '@/api/giasinput'
// Vuex 데이터 및 API 호출
const store = useStore();
const checkUserId = computed(() => store.state.temp.userInfo);

const isLoading = ref(false) // 로딩 상태 변수 추가

// 연도 콤보박스 선택된 값
const selectedYear = ref('2025');

// 연도 목록 (현재 연도부터 과거 5년까지)
const availableYears = ref(
      Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i)
    );


const tooltipVisible = reactive({});

// const handleDocumentClick = (e) => {
//   for (const key in tooltipVisible) {
//     tooltipVisible[key] = false;
//   }
// };

const handleDocumentClick = () => {
  Object.keys(tooltipVisible).forEach((key) => {
    tooltipVisible[key] = false;
  });
};


const handleTooltipClick = (code) => {
  // 이미 열려있는 경우(내가 다시 클릭) → 토글
  if (tooltipVisible[code]) {
    tooltipVisible[code] = false;
  } else {
    // 다른 모든 툴팁 닫기
    Object.keys(tooltipVisible).forEach((key) => {
      tooltipVisible[key] = false;
    });
    tooltipVisible[code] = true;
  }
};


// Vuex로부터 데이터 가져오기
const domainList = computed(() => store.state.grid.domainData); // 승인된 내부통제체계 진단 조회
// 저장된 내부통제체계 진단 조회
const orgEvlList = computed(() => {
	return store.state.grid.evlOrgData
})

// 수정시간을 클릭하면 그 시간에 수정한 내용이 매핑됨됨
const updateEvaluationContent = (evaluationCode, content,iqcCompletedYn) => {
  // 클릭한 시간에 매핑된 내용을 v-model에 업데이트

  if(iqcCompletedYn == 'Y'){
    evaluationContent[evaluationCode] = initialEvaluationContent[evaluationCode]
  }else{
    evaluationContent[evaluationCode] = content;
  }
};
// 현황 돌아가기 버튼
const resetEvaluationContent = (code) => {
  evaluationContent[code] = initialEvaluationContent[code] || ""; // 초기 데이터로 되돌림
};

// 개선사항 업데이트 로직
const updateEvaluationImprovements = (evaluationCode, content,iqcCompletedYn) => {
  if(iqcCompletedYn == "Y"){
    evaluationImprovements[evaluationCode] = initialEvaluationImprovements[evaluationCode];
  }else{
    evaluationImprovements[evaluationCode] = content;
  }
};


// 개선사항 업데이트 로직
const updateEvaluationMonitoring = (evaluationCode, content,iqcCompletedYn) => {
  if(iqcCompletedYn == "Y"){
    evaluationMonitoring[evaluationCode] = initialEvaluationMonitoring[evaluationCode];
  }else{
    evaluationMonitoring[evaluationCode] = content;
  }
};

const updateEvaluationAction = (evaluationCode, content,iqcCompletedYn) => {
  if(iqcCompletedYn == "Y"){
    evaluationAction[evaluationCode] = initialEvaluationAction[evaluationCode];
  }else{
    evaluationAction[evaluationCode] = content;
  }
};


// 개선사항 초기화 로직
const resetEvaluationAction = (evaluationCode) => {
  evaluationAction[evaluationCode] = initialEvaluationAction[evaluationCode] || "";
};
// 개선사항 초기화 로직
const resetEvaluationMonitoring = (evaluationCode) => {
  evaluationMonitoring[evaluationCode] = initialEvaluationMonitoring[evaluationCode] || "";
};

// 개선사항 초기화 로직
const resetEvaluationImprovements = (evaluationCode) => {
  evaluationImprovements[evaluationCode] = initialEvaluationImprovements[evaluationCode] || "";
};



// 검토 요청사항 업데이트 로직
const updateEvaluationComment = (evaluationCode, content,iqcCompletedYn) => {
  if(iqcCompletedYn == "Y"){
    evaluationComment[evaluationCode] = initialEvaluationComment[evaluationCode] || "";
  }else{
    evaluationComment[evaluationCode] = content;
  }
};

// 검토 요청사항 초기화 로직
const resetEvaluationComment = (evaluationCode) => {
  evaluationComment[evaluationCode] = initialEvaluationComment[evaluationCode] || "";
};


// 초기 데이터 상태 저장
let initialEvaluationContent = {};
let initialEvaluationImprovements = {};
let initialEvaluationMonitoring = {};
let initialEvaluationAction = {};
let initialEvaluationScore = {};
let initialEvaluationComment = {};

const hasData = ref(false);
const isSticky = ref(false);

// 점수에 따른 슬라이더 색상 반환
const getSliderColor = (score) => {
  if (score == 0) return '#808080'; // 회색
  if (score == 1) return '#f22805'; // 완전 빨간색
  if (score == 2) return '#f57a64'; // 약한 빨간색
  if (score == 3) return '#FFD700'; // 노란색
  if (score == 4) return '#00FF00'; // 연한 초록색색
  if (score == 5) return '#009000'; // 노란색
  return '#FFFFFF'; // 초록색
};

// 한글 부분 추출 (괄호 밖 텍스트)
const koreanPart = (text) => {
  if (!text) return '';
  // 영어 괄호 내용을 제거: 괄호 안이 영어로만 되어 있는 부분 삭제
  return text.replace(/\((?:[A-Za-z][^()]*)\)/g, '').trim();
};

// 영어 부분 추출 (괄호 안 텍스트)
const englishPart = (text) => {
  if (!text) return '';
  // 괄호 안의 영어만 추출
  const matches = text.match(/\(([A-Za-z][^()]*)\)/g);
  if (!matches || matches.length === 0) return '';
  // 마지막 괄호 기준 (원하면 처음 걸로도 가능)
  return matches[matches.length - 1].replace(/[()]/g, '').trim();
};



// 년도 불러오기기
// const loadYearData = async () => {
//   console.log(`📅 선택된 연도: ${selectedYear.value}`);
//   alert(`${selectedYear.value}년 데이터를 불러옵니다.`);
//   // 여기에 API 호출 또는 데이터 로직 추가
//   let param = {
//     organizationCode: checkUserId.value.organizationCode,
//     orgGiasYear : selectedYear.value
//   };
  
//   await store.dispatch("grid/fetchSelectPreviousYear", param);

//   if (Array.isArray(orgEvlList.value)) {
//     orgEvlList.value.forEach((savedEvl) => {
//       const code = savedEvl.evaluationCode;
//       if (code) {
//         // ✅ 기존 transformedDomains 매핑
//          //현황 내용
//         evaluationContent[code] = savedEvl.evaluationCurrent || "";
//         evaluationContent2[code] = savedEvl.evaluationCurrent2 || "";
//         evaluationContent3[code] = savedEvl.evaluationCurrent3 || "";
//         evaluationContent4[code] = savedEvl.evaluationCurrent4 || "";
//         evaluationContent5[code] = savedEvl.evaluationCurrent5 || "";
//         evaluationContent6[code] = savedEvl.evaluationCurrent6 || "";

//         //현황 수정 시간
//         evaluationCurrentTime[code] = savedEvl.evaluationCurrentTime || "";
//         evaluationCurrent2Time[code] = savedEvl.evaluationCurrent2Time || "";
//         evaluationCurrent3Time[code] = savedEvl.evaluationCurrent3Time || ""; 
//         evaluationCurrent4Time[code] = savedEvl.evaluationCurrent4Time || "";
//         evaluationCurrent5Time[code] = savedEvl.evaluationCurrent5Time || "";

//         //개선사항 내용
//         evaluationImprovements[code] = savedEvl.evaluationImp || "";
//         evaluationImprovements2[code] = savedEvl.evaluationImp2 || "";
//         evaluationImprovements3[code] = savedEvl.evaluationImp3 || "";
//         evaluationImprovements4[code] = savedEvl.evaluationImp4 || "";
//         evaluationImprovements5[code] = savedEvl.evaluationImp5 || "";
//         evaluationImprovements6[code] = savedEvl.evaluationImp6 || "";

//         // 권고사항 내용용
//         evaluationComment[code] = savedEvl.evaluationCmt || "";
//         evaluationComment2[code] = savedEvl.evaluationCmt2 || "";
//         evaluationComment3[code] = savedEvl.evaluationCmt3 || "";
//         evaluationComment4[code] = savedEvl.evaluationCmt4 || "";
//         evaluationComment5[code] = savedEvl.evaluationCmt5 || "";
//         evaluationComment6[code] = savedEvl.evaluationCmt6 || "";

//         //권고사항 수정 시간
//         evaluationCmtTime[code] = savedEvl.evaluationCmtTime || "";
//         evaluationCmtTime2[code] = savedEvl.evaluationCmt2Time || "";
//         evaluationCmtTime3[code] = savedEvl.evaluationCmt3Time || "";
//         evaluationCmtTime4[code] = savedEvl.evaluationCmt4Time || "";
//         evaluationCmtTime5[code] = savedEvl.evaluationCmt5Time || ""

//         //개선사항 수정 시간
//         evaluationImpTime[code] = savedEvl.evaluationImpTime || "";
//         evaluationImp2Time[code] = savedEvl.evaluationImp2Time || "";
//         evaluationImp3Time[code] = savedEvl.evaluationImp3Time || "";
//         evaluationImp4Time[code] = savedEvl.evaluationImp4Time || "";
//         evaluationImp5Time[code] = savedEvl.evaluationImp5Time || "";

//         // 모니터링
//         evaluationMonitoringTime[code] = savedEvl.evaluationMonitoringTime || "";
//         evaluationMonitoring2Time[code] = savedEvl.evaluationMonitoring2Time || "";
//         evaluationMonitoring3Time[code] = savedEvl.evaluationMonitoring3Time || "";
//         evaluationMonitoring4Time[code] = savedEvl.evaluationMonitoring4Time || "";
//         evaluationMonitoring5Time[code] = savedEvl.evaluationMonitoring5Time || "";

//         evaluationScore[code] = savedEvl.evaluationScore !== null ? savedEvl.evaluationScore : 0; // 기본값 0
//         completedYn[code] = savedEvl.completedYn || "";
//         iqcCompletedYn[code] = savedEvl.iqcCompletedYn || "";
//         iqaNeedsAttention[code] = savedEvl.iqaNeedsAttention || "";
//         iqcNeedsAttention[code] = savedEvl.iqcNeedsAttention || "";
//         eqcComment[code] = savedEvl.eqcComment || "";

//         // ✅ 파일 매핑
//         const filePaths = [
//           savedEvl.evaluationFile1,
//           savedEvl.evaluationFile2,
//           savedEvl.evaluationFile3,
//           savedEvl.evaluationFile4,
//           savedEvl.evaluationFile5,
//           savedEvl.evaluationFile6,
//           savedEvl.evaluationFile7,
//         ].filter(Boolean);

//         existingFiles[code] = filePaths.map((path) => ({
//           name: path.split("/").pop(),
//           path: path,
//         }));

//         evaluationFiles[code] = [...existingFiles[code]];

        
//       }
//     });
//   }

//   // 기본값 0으로 매핑되지 않은 항목 처리
//   transformedDomains.value.forEach((domain) => {
//     domain.principles.forEach((principle) => {
//       principle.standards.forEach((standard) => {
//         standard.evaluations.forEach((evaluation) => {
//           const code = evaluation.evaluationCode;
//           if (!evaluationScore[code]) {
//             evaluationScore[code] = 0; // 디폴트 값 0
//           }
//         });
//       });
//     });
//   });

//   propagateRedDot(transformedDomains.value);
// };

//슬라이더 버튼 옮기기
const updateSlider = (evaluationCode, event) => {
  // 슬라이더 값이 숫자로 변환되도록 보장
  evaluationScore[evaluationCode] = Number(event.target.value);
};

const handleScroll = () => {
    const stickyThreshold = 150; // 버튼이 고정될 스크롤 위치 (px)
    isSticky.value = window.scrollY > stickyThreshold;
};

// 도메인 클릭 이벤트
const selectedDomain = ref(null); // 선택된 도메인

const markFeedbackAsComplete = async (evaluationCode) => {
  try {
    let param = {
      organizationCode : checkUserId.value.organizationCode,
      evaluationCode : evaluationCode
	  }
    const response = await updateFeedbackCompletionStatus(param);

    if (response.result === "ok") {
      alert("피드백 완료 처리되었습니다.");
      iqcNeedsAttention[evaluationCode] = "N"; // 레드닷 상태 소멸
    } else {
      alert("피드백 완료 처리 중 오류가 발생했습니다.");
    }
  } catch (error) {
    console.error("피드백 완료 처리 오류:", error);
    alert("오류가 발생했습니다. 다시 시도해주세요.");
  }
};

const handleFileUpload = (evaluationCode, event) => {
  const files = Array.from(event.target.files); // 다중 파일 배열화

  if (!evaluationFiles[evaluationCode]) evaluationFiles[evaluationCode] = [];
  if (!newFiles[evaluationCode]) newFiles[evaluationCode] = [];

  files.forEach((file) => {
    evaluationFiles[evaluationCode].push(file);
    newFiles[evaluationCode].push(file); // 새로 추가된 파일
  });
};

const removeFile = (evaluationCode, fileIndex) => {
  const removedFile = evaluationFiles[evaluationCode].splice(fileIndex, 1)[0];

  // 삭제된 파일을 `deletedFiles`로 이동
  if (existingFiles[evaluationCode]?.some((file) => file.name === removedFile.name)) {
    if (!deletedFiles[evaluationCode]) deletedFiles[evaluationCode] = [];
    deletedFiles[evaluationCode].push(removedFile);
    // 기존 파일 배열에서 삭제
    existingFiles[evaluationCode] = existingFiles[evaluationCode].filter(
      (file) => file.name !== removedFile.name
    );
  } else {
    // 새로 추가된 파일 중 삭제
    newFiles[evaluationCode] = newFiles[evaluationCode].filter(
      (file) => file.name !== removedFile.name
    );
  }
};

//레드닷 전파 로직
const propagateRedDot = (domains) => {
  domains.forEach((domain) => {
    let domainHasRedDot = false;

    domain.principles.forEach((principle) => {
      let principleHasRedDot = false;

      principle.standards.forEach((standard) => {
        let standardHasRedDot = false;

        standard.evaluations.forEach((evaluation) => {
          if (iqcNeedsAttention[evaluation.evaluationCode] === "Y") {
            standardHasRedDot = true;
          }
        });

        // 상위 레벨로 레드닷 상태 전파
        if (standardHasRedDot) {
          principleHasRedDot = true;
          standard.hasRedDot = true; // UI 렌더링용
        }
      });

      if (principleHasRedDot) {
        domainHasRedDot = true;
        principle.hasRedDot = true; // UI 렌더링용
      }
    });

    if (domainHasRedDot) {
      domain.hasRedDot = true; // UI 렌더링용
    }
  });
};


const prepareKeepFiles = () => {
  const keepFiles = {};

  // ✅ 일반 평가 항목 파일
  Object.keys(existingFiles).forEach((code) => {
    keepFiles[code] = existingFiles[code].map((file) => file.path);
  });

  console.log("최종 유지할 파일 목록:", keepFiles);
  return keepFiles;
};

// ✅ 현황 값이 비어있는 평가 코드 찾기
const validateEvaluationContent = () => {
  const missingEvaluations = [];
  const missingEvaluations_A = [];

  transformedDomains.value.forEach((domain) => {
    domain.principles.forEach((principle) => {
      principle.standards.forEach((standard) => {
        standard.evaluations.forEach((evaluation) => {
          const code = evaluation.evaluationCode;
         if (
            !evaluationContent[code] || evaluationContent[code].trim() === "" ||
            !evaluationImprovements[code] || evaluationImprovements[code].trim() === "" ||
            !evaluationMonitoring[code] || evaluationMonitoring[code].trim() === "" ||
            !evaluationAction[code] || evaluationAction[code].trim() === ""
          ) {
            missingEvaluations.push(code);
          }
        });
      });
    });
  });

  return { missingEvaluations, missingEvaluations_A };
};

const finalSaveData = async (hasData) => {

  const missingEvaluations = validateEvaluationContent();

  
  if (missingEvaluations.missingEvaluations.length > 0) {
    alert(
      `🚨 아래 평가 코드의 현황 입력이 필요합니다:\n\n` +
      missingEvaluations.missingEvaluations.join(", ") + 
      `\n\n모든 항목을 입력 후 다시 시도해주세요.`
    );
    return false; // 🚨 현황이 비어 있으면 저장 중단
  }

  if (missingEvaluations.missingEvaluations_A.length > 0) {
    alert(
      `🚨 아래 평가 코드의 현황 입력이 필요합니다:\n\n` +
      missingEvaluations.missingEvaluations_A.join(", ") + 
      `\n\n모든 항목을 입력 후 다시 시도해주세요.`
    );
    return false; // 🚨 현황이 비어 있으면 저장 중단
  }

  isLoading.value = true; // 로딩 시작
  try {
    
    const saveResult = await saveData("final"); // 🚨 confirm 결과에 따라 실행될지 결정

    console.log("saveResult" + saveResult)
    if (saveResult == false) { 
      return false ; // 🚨 saveData가 중단되면 finalSaveData도 중단
    }

    const result = [];
    const formData = new FormData();

    // ✅ 일반 평가 항목 처리 (transformedDomains)
    transformedDomains.value.forEach((domain) => {
      domain.principles.forEach((principle) => {
        principle.standards.forEach((standard) => {
          standard.evaluations.forEach((evaluation) => {
            const code = evaluation.evaluationCode;

            const entry = {
              memberCode: checkUserId.value.memberCode,
              organizationCode: checkUserId.value.organizationCode,
              evaluationCode: code
            };

            result.push(entry);
          });
        });
      });
    });

    formData.append("data", JSON.stringify(result));

    formData.append("checkString", "Member");
    formData.append("memberCode", checkUserId.value.memberCode);
    const response = await finalizeEvaluation(formData);
    if (response.result === "ok") {
      alert(response.resultMsg)
      window.location.reload();
    } else {
      alert("수정에 실패했습니다.");
    }
  } catch (error) {
    console.error("저장 중 오류 발생:", error);
  } finally {
    isLoading.value = false; // 로딩 종료
  }
}



// Save Data 로직 수정
const saveData = async (check) => { 
  isLoading.value = true; // 로딩 시작
  try {
    const result = [];
    const formData = new FormData();

    let isFileLimitExceeded = false;

    // ✅ 일반 평가 항목 처리 (transformedDomains)
    transformedDomains.value.forEach((domain) => {
      domain.principles.forEach((principle) => {
        principle.standards.forEach((standard) => {
          standard.evaluations.forEach((evaluation) => {
            const code = evaluation.evaluationCode;
            const approvedCode = approvedCodes.value.map((c) => String(c).trim());
            if(approvedCode.includes(code)){
              const entry = {
                memberCode: checkUserId.value.memberCode,
                organizationCode: checkUserId.value.organizationCode,
                evaluationCode: code,
                evaluationScore: evaluationScore[code] || null,
                evaluationCurrent: evaluationContent[code] || null,
                evaluationImp: evaluationImprovements[code] || null,
                evaluationCmt: evaluationComment[code] || null,
                evaluationMonitoring: evaluationMonitoring[code] || null,
                evaluationAction: evaluationAction[code] || null,
                orgGiasYear : '2025',
                completedYn : 'N'
              };
              result.push(entry);

              // 파일 개수 확인
              const existingFileCount = existingFiles[code]?.length || 0;
              const newFileCount = newFiles[code]?.length || 0;
              const totalFileCount = existingFileCount + newFileCount;

              if (totalFileCount > 7) {
                isFileLimitExceeded = true;
              }

              // 새로 추가된 파일
              if (newFiles[code]) {
                newFiles[code].forEach((file) => {
                  formData.append(`files[${code}][]`, file);
                });
              }
            }
          });
        });
      });
    });
    
    // ✅ 파일 제한 초과 시 경고 및 실행 중단
    if (isFileLimitExceeded) {
      alert("첨부파일은 평가 코드당 최대 7개까지만 가능합니다.");
      return;
    }

    // ✅ 유지할 파일
    const keepFiles = prepareKeepFiles();
    formData.append("keepFiles", JSON.stringify(keepFiles));

    formData.append("data", JSON.stringify(result));

    // ✅ 서버로 데이터 전송
    try {
      if (check === "insert") {
        if (confirm("저장 하시겠습니까?")) {
          const response = await insertGias(formData);
          if (response.result === "ok") {
            alert("저장에 성공했습니다.");
            window.location.reload();
          } else {
            alert("저장에 실패했습니다.");
          }
        }
      } 
      
      if(check === "update") {
        if (confirm("수정 하시겠습니까?")) {
          formData.append("checkUser", "admin");
          formData.append("memberCode", checkUserId.value.memberCode);
          formData.append("orgCode", checkUserId.value.organizationCode);
          const response = await updateGias(formData);
          if (response.result === "ok") {
            formData.append("organizationCode", checkUserId.value.organizationCode);
            const rtn = await updateGiasFile(formData);
            if (rtn.result === "ok") {
              alert("수정에 성공했습니다.");
              window.location.reload();
            } else {
              alert("파일 수정에 실패했습니다.");
            }
          } else {
            alert("수정에 실패했습니다.");
          }
        }
      }

      if(check === "final") {
        if (!confirm("평가완료 하시겠습니까? 평가완료 후 수정이 불가능합니다. ")) {
          return false
        }
          formData.append("checkUser", "admin");
          formData.append("memberCode", checkUserId.value.memberCode);
          formData.append("orgCode", checkUserId.value.organizationCode);
          const response = await updateGias(formData);
          if (response.result === "ok") {
            formData.append("organizationCode", checkUserId.value.organizationCode);
            const rtn = await updateGiasFile(formData);
            if (rtn.result === "ok") {

            } else {
              alert("파일 수정에 실패했습니다.");
            }
          } else {
            alert("수정에 실패했습니다.");
          }
      }


    } catch (error) {
      console.error("저장 중 오류 발생:", error);
      alert("오류가 발생했습니다.");
    }
  } catch (error) {
    console.error("저장 중 오류 발생:", error);
  } finally {
    isLoading.value = false; // 로딩 종료
  }
};

// 변경된 항목의 코멘트와 상태값만 변경시킴킴
const SaveCmt = async () => { 
  isLoading.value = true; // 로딩 시작
  try {
    const result = [];
    const formData = new FormData();

    // ✅ 변경된 코멘트만 추출
    transformedDomains.value.forEach((domain) => {
      domain.principles.forEach((principle) => {
        principle.standards.forEach((standard) => {
          standard.evaluations.forEach((evaluation) => {
            const code = evaluation.evaluationCode;

            // 기존 데이터와 비교
            if (evaluationComment[code] !== initialEvaluationComment[code]) {
              const entry = {
                memberCode: checkUserId.value.memberCode,
                organizationCode: checkUserId.value.organizationCode,
                evaluationCode: code,
                evaluationCmt: evaluationComment[code] || null // 변경된 코멘트
              };
              result.push(entry);
            }
          });
        });
      });
    });

    if (result.length === 0) {
      alert("변경된 요청사항이 없습니다.");
      return;
    }

    formData.append("data", JSON.stringify(result));

    // ✅ 서버로 데이터 전송
    try {
      const response = await updateFeedbackForIQA(formData);
      if (response.result === "ok") {
        alert("검토 요청사항 저장에 성공했습니다.");
        window.location.reload();
      } else {
        alert("수정에 실패했습니다.");
      }
    } catch (error) {
      console.error("저장 중 오류 발생:", error);
      alert("오류가 발생했습니다.");
    }
  } catch (error) {
    console.error("저장 중 오류 발생:", error);
  } finally {
    isLoading.value = false; // 로딩 종료
  }
};



// 트리 구조 변환 함수
const transformToTreeStructure = (data) => {
  const groupedData = {};

  data.forEach((item) => {
    if (!groupedData[item.domainCode]) {
      groupedData[item.domainCode] = {
        domainCode: item.domainCode,
        domainName: item.domainName,
        principles: {},
      };
    }
    const domain = groupedData[item.domainCode];

    if (!domain.principles[item.principleCode]) {
      domain.principles[item.principleCode] = {
        principleCode: item.principleCode,
        principleName: item.principleName,
        principleContent:item.principleContent,
        standards: {},
      };
    }
    const principle = domain.principles[item.principleCode];

    if (!principle.standards[item.standardCode]) {
      principle.standards[item.standardCode] = {
        standardCode: item.standardCode,
        standardName: item.standardName,
        standardContent: item.standardContent,
        evaluations: [],
      };
    }
    const standard = principle.standards[item.standardCode];

    standard.evaluations.push({
      evaluationCode: item.evaluationCode,
      evaluationName: item.evaluationName,
      evaluationApproachContent : item.evaluationApproachContent,
      evaluationDeploymentContent : item.evaluationDeploymentContent,
      evaluationMonitoringContent : item.evaluationMonitoringContent,
      evaluationActionContent : item.evaluationActionContent
    });
  });

  return Object.values(groupedData).map((domain) => ({
    ...domain,
    principles: Object.values(domain.principles).map((principle) => ({
      ...principle,
      standards: Object.values(principle.standards),
    })),
  }));
};


// 트리 변환된 데이터
const transformedDomains = computed(() => transformToTreeStructure(domainList.value));

// 토글 상태
const subItemsVisibility = reactive({});
const subItemsVisibilityStandard = reactive({});
const evaluationVisibility = reactive({});

// 평가 데이터 상태
const evaluationContent = reactive({});
const evaluationContent2 = reactive({});
const evaluationContent3 = reactive({});
const evaluationContent4 = reactive({});
const evaluationContent5 = reactive({});
const evaluationContent6 = reactive({});
//현황 수정 시간
const evaluationCurrentTime = reactive({});
const evaluationCurrent2Time = reactive({});
const evaluationCurrent3Time = reactive({});
const evaluationCurrent4Time = reactive({});
const evaluationCurrent5Time = reactive({});


//개선사항 데이터 상세
const evaluationImprovements = reactive({});
const evaluationImprovements2 = reactive({});
const evaluationImprovements3 = reactive({});
const evaluationImprovements4 = reactive({});
const evaluationImprovements5 = reactive({});
const evaluationImprovements6 = reactive({});

//개선사항 수정 로그 시간
const evaluationImpTime = reactive({});
const evaluationImp2Time = reactive({});
const evaluationImp3Time = reactive({});
const evaluationImp4Time = reactive({});
const evaluationImp5Time = reactive({});

// 모니터링 데이터 상세
const evaluationMonitoring = reactive({});
const evaluationMonitoring2 = reactive({});
const evaluationMonitoring3 = reactive({});
const evaluationMonitoring4 = reactive({});
const evaluationMonitoring5 = reactive({});
const evaluationMonitoring6 = reactive({});

//모니터링 수정 로그 시간
const evaluationMonitoringTime = reactive({});
const evaluationMonitoring2Time = reactive({});
const evaluationMonitoring3Time = reactive({});
const evaluationMonitoring4Time = reactive({});
const evaluationMonitoring5Time = reactive({});

// 액션 데이터 상세
const evaluationAction = reactive({});
const evaluationAction2 = reactive({});
const evaluationAction3 = reactive({});
const evaluationAction4 = reactive({});
const evaluationAction5 = reactive({});
const evaluationAction6 = reactive({});

//액션 수정 로그 시간
const evaluationActionTime = reactive({});
const evaluationAction2Time = reactive({});
const evaluationAction3Time = reactive({});
const evaluationAction4Time = reactive({});
const evaluationAction5Time = reactive({});

//권고사항 데이터 상세
const evaluationComment = reactive({});
const evaluationComment2 = reactive({});
const evaluationComment3 = reactive({});
const evaluationComment4 = reactive({});
const evaluationComment5 = reactive({});
const evaluationComment6 = reactive({});

//권고사항 수정 로그시간
const evaluationCmtTime = reactive({});
const evaluationCmtTime2 = reactive({});
const evaluationCmtTime3 = reactive({});
const evaluationCmtTime4 = reactive({});
const evaluationCmtTime5 = reactive({});




const evaluationScore = reactive({});
const evaluationFiles = reactive({});
const completedYn = reactive({});
const iqcCompletedYn = reactive({});
const iqaNeedsAttention = reactive({});
const iqcNeedsAttention = reactive({});
const eqcComment = reactive({}); // EQC가 작성한 피드백
//파일 관리 상태
const existingFiles = reactive({}); // 존재하는 파일
const newFiles = reactive({}); // 새로운 파일
const deletedFiles = reactive({}); // 삭제할 파일

// 승인된 평가 코드 상태 저장
const approvedCodes = ref([]);

// 모든 평가 항목의 수와 iqcCompletedYn === "Y"인 항목 수를 계산
const giasCount = computed(() => Object.keys(iqcCompletedYn).length);
const iqcCompletedYnCount = computed(() =>
  Object.values(iqcCompletedYn).filter((value) => value === "Y").length
);

// 제출 버튼 비활성화 조건 계산
const isSubmitDisabled = computed(() => {
  // 데이터가 없는 경우 항상 false (저장 가능)
  if (giasCount.value === 0) {
    return false;
  }
  // 모든 항목이 완료된 경우만 true
  return giasCount.value === iqcCompletedYnCount.value;
});
// 토글 함수
// 도메인 토글
const toggleSubItem = (domainCode) => {
  subItemsVisibility[domainCode] = !subItemsVisibility[domainCode];
};

// 프린서펄 토글
const toggleSubItemStandard = (domainCode, principleCode) => {
  const key = `${domainCode}-${principleCode}`;
  subItemsVisibilityStandard[key] = !subItemsVisibilityStandard[key];
};

// 스탠다드 토글
const toggleSubItemEvaluation = (domainCode, principleCode, standardCode) => {
  const key = `${domainCode}-${principleCode}-${standardCode}`;
  evaluationVisibility[key] = !evaluationVisibility[key];
};



// 모든 내부통제체계 진단 항목을 가져오기기
const getGridData = async () => {

  await store.dispatch("grid/fetchGiasAllData");
};

//IQC에게 승인된 항목이 무엇인지 확인함
const getUserData = async () => {
  let param = {
    memberCode: checkUserId.value.memberCode
  };

  try {
    let rtn = await getIQCApproveList(param);
    approvedCodes.value = rtn.data || []; // 평가 코드 리스트 저장
    console.log("승인된 평가 코드:", approvedCodes.value);
  } catch (error) {
    console.error("IQC 승인된 항목 조회 실패:", error);
  }
};

// 파라미터로 넣은 기업의 평가원들이 작성한 모든 데이터를 가져옴
const getEvlData = async () => {
  let param = {
    organizationCode: checkUserId.value.organizationCode,
    orgGiasYear : selectedYear.value
  };
  await store.dispatch("grid/fetchAdminEvlOrg", param);

  if (Array.isArray(orgEvlList.value)) {
    orgEvlList.value.forEach((savedEvl) => {
      const code = savedEvl.evaluationCode;
      if (code) {
        // ✅ 기존 transformedDomains 매핑
         //현황 내용
        evaluationContent[code] = savedEvl.evaluationCurrent || "";
        evaluationContent2[code] = savedEvl.evaluationCurrent2 || "";
        evaluationContent3[code] = savedEvl.evaluationCurrent3 || "";
        evaluationContent4[code] = savedEvl.evaluationCurrent4 || "";
        evaluationContent5[code] = savedEvl.evaluationCurrent5 || "";
        evaluationContent6[code] = savedEvl.evaluationCurrent6 || "";

        //현황 수정 시간
        evaluationCurrentTime[code] = savedEvl.evaluationCurrentTime || "";
        evaluationCurrent2Time[code] = savedEvl.evaluationCurrent2Time || "";
        evaluationCurrent3Time[code] = savedEvl.evaluationCurrent3Time || ""; 
        evaluationCurrent4Time[code] = savedEvl.evaluationCurrent4Time || "";
        evaluationCurrent5Time[code] = savedEvl.evaluationCurrent5Time || "";

        //개선사항 내용
        evaluationImprovements[code] = savedEvl.evaluationImp || "";
        evaluationImprovements2[code] = savedEvl.evaluationImp2 || "";
        evaluationImprovements3[code] = savedEvl.evaluationImp3 || "";
        evaluationImprovements4[code] = savedEvl.evaluationImp4 || "";
        evaluationImprovements5[code] = savedEvl.evaluationImp5 || "";
        evaluationImprovements6[code] = savedEvl.evaluationImp6 || "";

        // 권고사항 내용용
        evaluationComment[code] = savedEvl.evaluationCmt || "";
        evaluationComment2[code] = savedEvl.evaluationCmt2 || "";
        evaluationComment3[code] = savedEvl.evaluationCmt3 || "";
        evaluationComment4[code] = savedEvl.evaluationCmt4 || "";
        evaluationComment5[code] = savedEvl.evaluationCmt5 || "";
        evaluationComment6[code] = savedEvl.evaluationCmt6 || "";

         // 모니터링 내용
        evaluationMonitoring[code] =  savedEvl.evaluationMonitoring || "";
        evaluationMonitoring2[code] = savedEvl.evaluationMonitoring2 || "";
        evaluationMonitoring3[code] = savedEvl.evaluationMonitoring3 || "";
        evaluationMonitoring4[code] = savedEvl.evaluationMonitoring4 || "";
        evaluationMonitoring5[code] = savedEvl.evaluationMonitoring5 || "";
        evaluationMonitoring6[code] = savedEvl.evaluationMonitoring6 || "";

        // 모니터링 수정시간
        evaluationMonitoringTime[code] =  savedEvl.evaluationMonitoringTime || "";
        evaluationMonitoring2Time[code] = savedEvl.evaluationMonitoring2Time || "";
        evaluationMonitoring3Time[code] = savedEvl.evaluationMonitoring3Time || "";
        evaluationMonitoring4Time[code] = savedEvl.evaluationMonitoring4Time || "";
        evaluationMonitoring5Time[code] = savedEvl.evaluationMonitoring5Time || ""


        // 액션 내용
        evaluationAction[code] =  savedEvl.evaluationAction || "";
        evaluationAction2[code] = savedEvl.evaluationAction2 || "";
        evaluationAction3[code] = savedEvl.evaluationAction3 || "";
        evaluationAction4[code] = savedEvl.evaluationAction4 || "";
        evaluationAction5[code] = savedEvl.evaluationAction5 || "";
        evaluationAction6[code] = savedEvl.evaluationAction6 || "";

        // 액션 수정시간
        evaluationActionTime[code] =  savedEvl.evaluationActionTime || "";
        evaluationAction2Time[code] = savedEvl.evaluationAction2Time || "";
        evaluationAction3Time[code] = savedEvl.evaluationAction3Time || "";
        evaluationAction4Time[code] = savedEvl.evaluationAction4Time || "";
        evaluationAction5Time[code] = savedEvl.evaluationAction5Time || ""

        //권고사항 수정 시간
        evaluationCmtTime[code] = savedEvl.evaluationCmtTime || "";
        evaluationCmtTime2[code] = savedEvl.evaluationCmt2Time || "";
        evaluationCmtTime3[code] = savedEvl.evaluationCmt3Time || "";
        evaluationCmtTime4[code] = savedEvl.evaluationCmt4Time || "";
        evaluationCmtTime5[code] = savedEvl.evaluationCmt5Time || ""

        //개선사항 수정 시간
        evaluationImpTime[code] = savedEvl.evaluationImpTime || "";
        evaluationImp2Time[code] = savedEvl.evaluationImp2Time || "";
        evaluationImp3Time[code] = savedEvl.evaluationImp3Time || "";
        evaluationImp4Time[code] = savedEvl.evaluationImp4Time || "";
        evaluationImp5Time[code] = savedEvl.evaluationImp5Time || "";

        evaluationScore[code] = savedEvl.evaluationScore !== null ? savedEvl.evaluationScore : 0; // 기본값 0
        completedYn[code] = savedEvl.completedYn || "";
        iqcCompletedYn[code] = savedEvl.iqcCompletedYn || "";
        iqaNeedsAttention[code] = savedEvl.iqaNeedsAttention || "";
        iqcNeedsAttention[code] = savedEvl.iqcNeedsAttention || "";
        eqcComment[code] = savedEvl.eqcComment || "";

        // ✅ 파일 매핑
        const filePaths = [
          savedEvl.evaluationFile1,
          savedEvl.evaluationFile2,
          savedEvl.evaluationFile3,
          savedEvl.evaluationFile4,
          savedEvl.evaluationFile5,
          savedEvl.evaluationFile6,
          savedEvl.evaluationFile7,
        ].filter(Boolean);

        existingFiles[code] = filePaths.map((path) => ({
          name: path.split("/").pop(),
          path: path,
        }));

        evaluationFiles[code] = [...existingFiles[code]];
      }
    });
  }

  // 기본값 0으로 매핑되지 않은 항목 처리
  transformedDomains.value.forEach((domain) => {
    domain.principles.forEach((principle) => {
      principle.standards.forEach((standard) => {
        standard.evaluations.forEach((evaluation) => {
          const code = evaluation.evaluationCode;
          if (!evaluationScore[code]) {
            evaluationScore[code] = 0; // 디폴트 값 0
          }
        });
      });
    });
  });

  propagateRedDot(transformedDomains.value);
};



onMounted(async () => {
    //document.addEventListener('click', handleDocumentClick);

    await getGridData();
    const gridDataAvailable = domainList.value && domainList.value.length > 0;

    await getEvlData();
    const evlDataAvailable = orgEvlList.value && orgEvlList.value.length > 0;

    await getUserData();

    //console.log("테스트" + checkUserId.value.reviewCompletedYn)
    // 버튼 표시 로직 설정
    if (!gridDataAvailable && !evlDataAvailable) {
        alert("저장할 항목 또는 수정할 항목이 없습니다. 관리자에게 문의해주세요");
        hasData.value = false; // 버튼 숨김
    } else if (gridDataAvailable && !evlDataAvailable) {
        hasData.value = "insert"; // "저장" 버튼
    } else if (gridDataAvailable && evlDataAvailable) {
        hasData.value = "update"; // "수정" 버튼
    } else {
        hasData.value = false; // 버튼 숨김
    }

    if (Array.isArray(orgEvlList.value)) {
      orgEvlList.value.forEach((savedEvl, index) => {
      //console.log(`[${index + 1}] 항목 데이터:`, savedEvl); // 각 항목의 전체 구조 출력

      const code = savedEvl.evaluationCode; // evaluationCode 확인
      if (code) {
          // 데이터 매핑
          evaluationContent[code] = savedEvl.evaluationCurrent || "";
          evaluationImprovements[code] = savedEvl.evaluationImp || "";
          evaluationComment[code] = savedEvl.evaluationCmt || "";
          evaluationMonitoring[code] = savedEvl.evaluationMonitoring || "";
          evaluationAction[code] = savedEvl.evaluationAction || "";
          evaluationScore[code] = savedEvl.evaluationScore || 0;
          completedYn[code] = savedEvl.completedYn || "";
      }
      });
    } 

     // ✅ A 도메인 데이터 초기화
    console.log("hasData 상태:", hasData.value); // 디버깅용
    window.addEventListener("scroll", handleScroll);

     // 초기 데이터를 깊은 복사로 저장
    initialEvaluationContent = JSON.parse(JSON.stringify(toRaw(evaluationContent)));
    initialEvaluationImprovements = JSON.parse(JSON.stringify(toRaw(evaluationImprovements)));
    initialEvaluationMonitoring = JSON.parse(JSON.stringify(toRaw(evaluationMonitoring)));
    initialEvaluationAction = JSON.parse(JSON.stringify(toRaw(evaluationAction)));
    initialEvaluationComment = JSON.parse(JSON.stringify(toRaw(evaluationComment)));
    initialEvaluationScore = JSON.parse(JSON.stringify(toRaw(evaluationScore)));

  console.log("Initial giasCount:", giasCount.value);
  console.log("Initial completedYnCount:", iqcCompletedYnCount.value);
  console.log("Initial isSubmitDisabled:", isSubmitDisabled.value);

  transformedDomains.value.forEach((domain) => {
    const domainKey = domain.domainCode;
    subItemsVisibility[domainKey] = false;

    // Level 2: 프린서펄 상태 초기화
    domain.principles.forEach((principle) => {
      const principleKey = `${domainKey}-${principle.principleCode}`;
      subItemsVisibilityStandard[principleKey] = false;

      // Level 3: 스탠다드 상태 초기화
      principle.standards.forEach((standard) => {
        const standardKey = `${principleKey}-${standard.standardCode}`;
        evaluationVisibility[standardKey] = false;
      });
    });
  });


});

onUnmounted(() => {
  //document.removeEventListener('click', handleDocumentClick);
	// 페이지 닫힐 때 해당 리스너 삭제
  const isContentChanged = JSON.stringify(toRaw(evaluationContent)) !== JSON.stringify(initialEvaluationContent);
  const isImprovementsChanged = JSON.stringify(toRaw(evaluationImprovements)) !== JSON.stringify(initialEvaluationImprovements);
  const isCommentChanged = JSON.stringify(toRaw(evaluationComment)) !== JSON.stringify(initialEvaluationComment);
  const isScoreChanged = JSON.stringify(toRaw(evaluationScore)) !== JSON.stringify(initialEvaluationScore);

  if (isContentChanged || isImprovementsChanged || isScoreChanged || isCommentChanged) {
      //saveData(hasData.value); // 데이터가 변경된 경우만 저장
  } 
}) 


</script>


<style scoped>

/* ✅ Readonly 상태의 textarea 스타일 */
textarea[readonly] {
  background-color: #f0f0f0; /* 회색 배경 */
  color: #666; /* 텍스트 색상 */
  cursor: not-allowed; /* 마우스 커서 */
  border: 1px solid #ccc; /* 경계선 */
}


.year-dropdown {
  margin-left: 10px; /* 간격 추가 */
  padding: 2px 2px; /* 내부 패딩 */
  border: 1px solid #ccc; /* 테두리 스타일 */
  border-radius: 4px; /* 둥근 모서리 */
  font-size: 14px; /* 글꼴 크기 */
  cursor: pointer; /* 포인터 커서 */
  height: 25px;
  width: 50px;
  text-align: center;
}

.year-dropdown:focus {
  border-color: #0078d7; /* 포커스 시 테두리 색상 변경 */
  outline: none;
}

.load-button {
  margin-left: 10px; /* 간격 추가 */
  padding: 5px 15px; /* 내부 패딩 */
  background-color: #0078d7; /* 버튼 배경색 */
  color: white; /* 글자색 */
  border: none; /* 테두리 제거 */
  border-radius: 4px; /* 둥근 모서리 */
  cursor: pointer; /* 포인터 커서 */
  font-size: 14px; /* 글꼴 크기 */
}

.load-button:hover {
  background-color: #005bb5; /* 호버 시 색상 변경 */
}

/* 도움말 아이콘 */
.help-icon-wrapper {
  position: relative;
  display: inline-block;
  margin-right: 8px; /* 프린서펄이름과 간격 추가 */
  margin-left: 8px; /* 레드닷과 간격 추가 */
  vertical-align: middle; /* 아이콘이 텍스트와 중간 정렬되도록 */
}

.help-icon {
  width: 20px;
  height: 20px;
  background-color: #005bb5;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

/* 툴팁 스타일 */
.tooltip {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px; /**줄간격 */
  visibility: hidden;
  background-color: #fff;
  color: #000;
  text-align: left;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: 120%; /* 부모의 중앙을 기준으로 위치 */
  left: 100%; /* 아이콘의 오른쪽에 위치 */
  transform: translate(20px, -50%); /* Y축 -50%로 중앙 정렬 */
  white-space: pre-wrap; /* 줄바꿈 허용 */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  max-width: 700px; /* 최대 너비 제한 */
  width: max-content; /* 내용에 맞춰 너비 설정 */
  visibility: hidden;
}
/* 보이는 상태만 따로 */
.tooltip.visible {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}
.tooltip-stand {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px; /**줄간격 */
  visibility: hidden;
  background-color: #fff;
  color: #000;
  text-align: left;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: 50%; /* 부모의 중앙을 기준으로 위치 */
  left: 100%; /* 아이콘의 오른쪽에 위치 */
  transform: translate(20px, -50%); /* Y축 -50%로 중앙 정렬 */
  white-space: pre-wrap; /* 줄바꿈 허용 */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  width: 300px;
}

.help-icon-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.help-icon-wrapper:hover .tooltip-stand {
  visibility: visible;
  opacity: 1;
}

.red-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  margin-left: 5px;
  vertical-align: middle;
}
.red-text {
  color: red;
  font-weight: bold;
  font-size: 12px;
  margin-left: 5px;
}
.layout-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 최소 높이를 뷰포트 높이로 설정 */
}
.footer {
  background-color: #FFFFFF; /* 배경색 지정 */
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
}
.attach-list{
  margin-top: -10px;
  font-size: 14px;
  margin-left: 80px;
}
/* ✅ 저장 버튼 */
.save-button-container {
margin-top: 20px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  gap: 10px; /* 버튼 사이 간격 */
}

.save-button-container button {
  background-color: #0078d7;
  color: white;
  border-radius: 5px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

/* ✅ 최종 저장 버튼 스타일 (선택적 스타일 추가) */
.save-button-container button:last-child {
  background-color: #28a745; /* 초록색 버튼 */
}

/* 비활성화 상태 */
button:disabled {
  cursor: not-allowed; /* 금지 커서 */
  opacity: 0.2; /* 투명도 */
}

/* ✅ 트리 노드 스타일 */
.tree-node {
  border: 1px solid #ddd;
  border-radius: 5px;
  margin: 10px 0;
  padding: 14px;
  background-color: #f9fafc;
}

.level-1 {
  background-color: #CDE7FA;
  cursor: pointer;
}

.level-2 {
  background-color: #D7EFFB;
  margin-left: 20px;
}

.level-3 {
  background-color: #E3F2FD;
  margin-left: 20px;
}

.level-4 {
  background-color: #F1F8FE;
  cursor: default ;
  margin-left: 20px;
}

.node-title {
  font-weight: bold;
}
/* 한글 스타일 */
.node-title .korean-text {
  font-size: 16px;
}

/* 영어 스타일 */
.node-title .english-text {
  font-size: 10px;
}

/* ✅ 입력 그룹 */
.input-group {
  display: flex;
  align-items: flex-start; /* 텍스트박스와 수정 시간 정렬 */
  margin: 20px 0;
  gap: 10px; /* 입력창과 수정 시간 간격 추가 */
}

/* ✅ 텍스트 영역 래퍼 */
.textarea-wrapper {
  flex: 0 0 80%; /* 입력창을 80%로 설정 */
}

.textarea-wrapper textarea {
  height: 160px; /* 수정 시간 박스와 동일한 높이 설정 */
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  resize: vertical; /* 사용자가 세로로 크기 조정 가능 */
}

.input-group label {
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
  white-space: nowrap; /* 텍스트가 줄바꿈되지 않도록 설정 */
}

.input-group textarea {
  width: 100%;
  height: 160px; /* 기존 높이에 +15px 추가 */
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  resize: vertical; /* 사용자가 세로로만 크기 조정 가능 */
}

/* ✅ 수정 시간 표시 박스 */

.timestamp-item {
  margin-bottom: 8px; /* 각 항목 간격 */
  color: #007bff; /* 파란색 텍스트 */
  text-decoration: underline; /* 밑줄 추가 */
  cursor : pointer;
}
/* 금지 커서와 스타일 변경 */
.timestamp-item.disabled {
  opacity: 0.5; /* 흐리게 표시 */
  cursor: not-allowed; /* 금지 커서 */
}
.timestamp-item:hover {
  background-color: #f0f0f0;
}

.textarea-wrapper.full-width {
  flex: 0 0 100%; /* textarea가 전체 너비를 차지 */
}


.timestamp-box {
  flex: 0 0 20%; /* 나머지 20% 할당 */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.timestamp-box label {
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 5px;
}

.timestamp {
  padding: 8px;
  background-color: #f9f9f9; /* 수정 시간 표시 영역 배경 */
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  height: 160px; /* 자동 높이 조정 */
  display: flex;
  flex-direction: column; /* 세로 정렬 */
  align-items: flex-start; /* 왼쪽 정렬 */
  gap: 8px; /* 각 항목 간격 추가 */
  color: #666; /* 텍스트 색상 */
  overflow-y: auto;
}

.return-button-wrapper {
  margin-top: 10px;
}

.return-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.return-button:hover {
  background-color: #0056b3;
}

/* ✅ 슬라이더 컨테이너 */
.custom-slider {
  position: relative;
  width: 300px;
  height: 30px;
  margin: 20px 0;
}


/* ✅ 슬라이더 트랙 (배경선) */
.custom-slider input[type="range"] {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  background: linear-gradient(to right, 
    #FF6F61 0%,   /* 왼쪽 초록색 */
    #FFD700 50%,  /* 중간 노란색 */
    #00FF00 100%  /* 오른쪽 빨간색 00FF00*/
  );
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  z-index: 1;
  position: relative;
}

/* ✅ 슬라이더 핸들 (드래그 원 + 점수 표시) */
.slider-thumb {
  position: absolute;
  top: -4px; /* 핸들 위치 조정 */
  transform: translateX(70%);
  color: white;
  font-size: 14px;
  font-weight: bold;
  padding: 5px 17px; /* 내부 패딩 추가 */
  border-radius: 20px; /* 둥근 직사각형 */
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 4px 8px rgba(168, 85, 247, 0.3);
  z-index: 2;
  pointer-events: none; /* 드래그 이벤트 방지 */
  line-height: 1.2;
  background: var(--slider-color, #A8E6CF); /* 기본 색상 (연한 초록) */
}

/* ✅ 점수 텍스트 포맷 */
.slider-thumb::after {
  margin-left: 2px;
  font-size: 12px;
  font-weight: normal;
}


/* ✅ 슬라이더 선택 영역 (선택된 부분) */
.slider-track {
  position: absolute;
  top: 50%;
  left: 0;
  height: 8px;
  border-radius: 10px;
  background: var(--slider-color, #A8E6CF); /* 선택된 부분 색상 */
  transform: translateY(-50%);
  z-index: 0;
  transition: width 0.2s ease-in-out;
}
</style>
